import { CustomSwiper } from "./CustomSwiper";

interface ImageActionKeysMap {
  [imageUrl: string]: Set<string>;
}

interface Props {
  images?: string[];
  imageActionKeysMap?: ImageActionKeysMap;
}

export const DeliveryGroupSwiper: React.FC<Props> = ({ images, imageActionKeysMap }) => (
  <CustomSwiper
    sx={{
      width: "501px",
      height: "671px",
      borderbottomleftradius: "8px",
    }}
    imgItemsContents={images}
    imageActionKeysMap={imageActionKeysMap}
  />
);

// const Swiper = styled(CustomSwiper)`
//   width: 501px;
//   height: 668px;
//   border-bottom-left-radius: 8px;
// `;
